import React from 'react';
import TimelineGraficIcon from '@mui/icons-material/TimelineRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import HistoryIcon from '@mui/icons-material/History';
import BatteryIcon from '@mui/icons-material/Battery90Rounded';
import LightIcon from '@mui/icons-material/WbIncandescent';
import HumidityIcon from '@mui/icons-material/Opacity';
import MapIcon from '@mui/icons-material/Map';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import OutlinedFlagRoundedIcon from '@mui/icons-material/OutlinedFlagRounded';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import DevicesIcon from '@mui/icons-material/StorageRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Badge from '@mui/material/Badge';
import TemperatureIcon from './temperature';
import OrientationIcon from './orientation';
import PressureIcon from './pressure';
import ShockIcon from './shock';

// issue https://github.com/mui/material-ui/issues/40032#issuecomment-1848858497
const colorRed = '#FF4635';

function createLabel(icon, measurement, isActive, isMobile, count) {
  if (isMobile) {
    return (
      <>
        {icon}
        {isActive && (
          <>
            <span>{measurement}</span>
            {count && <span>{`(${count})`}</span>}
          </>
        )}
      </>
    );
  }
  return (
    <>
      {icon}
      <span>{measurement}</span>
      {count && <span>{`(${count})`}</span>}
    </>
  );
}

export default (identifier, isActive, isMobile, params = {}) => {
  switch (identifier) {
    case 'info': {
      return createLabel(<InfoOutlinedIcon title={identifier} />, identifier, isActive, isMobile);
    }
    case 'events': {
      return createLabel(<HistoryIcon title={identifier} />, identifier, isActive, isMobile);
    }
    case 'devices': {
      const { devices, selectedDevices } = params;
      const uniqDevices = [...new Set(devices.map(d => d.uid))];
      return createLabel(
        <Badge
          color="secondary"
          variant="dot"
          invisible={uniqDevices.length === selectedDevices.length}
          overlap="rectangular" // the console throws an error
        >
          <DevicesIcon title={identifier} />
        </Badge>,
        identifier,
        isActive,
        isMobile
      );
    }
    case 'temperature': {
      const fill = params.isExcursion ? colorRed : 'currentColor';
      return createLabel(
        <TemperatureIcon title={identifier} fill={fill} />,
        identifier,
        isActive,
        isMobile
      );
    }
    case 'orientation': {
      const fill = params.isExcursion ? colorRed : 'currentColor';
      return createLabel(
        <OrientationIcon title={identifier} fill={fill} />,
        identifier,
        isActive,
        isMobile
      );
    }
    case 'pressure': {
      const fill = params.isExcursion ? colorRed : 'currentColor';
      return createLabel(
        <PressureIcon title={identifier} fill={fill} />,
        identifier,
        isActive,
        isMobile
      );
    }
    case 'shock': {
      const fill = params.isExcursion ? colorRed : 'currentColor';
      return createLabel(
        <ShockIcon title={identifier} fill={fill} />,
        identifier,
        isActive,
        isMobile
      );
    }
    case 'humidity': {
      return createLabel(<HumidityIcon title={identifier} />, identifier, isActive, isMobile);
    }
    case 'battery': {
      return createLabel(<BatteryIcon title={identifier} />, identifier, isActive, isMobile);
    }
    case 'light': {
      return createLabel(<LightIcon title={identifier} />, identifier, isActive, isMobile);
    }
    case 'map': {
      return createLabel(<MapIcon title={identifier} />, identifier, isActive, isMobile);
    }
    case 'NOT_STARTED': {
      return createLabel(
        <UpdateRoundedIcon title={identifier} />,
        identifier.replace('_', ' '),
        isActive,
        isMobile,
        params
      );
    }
    case 'IN_PROGRESS': {
      return createLabel(
        <AutorenewRoundedIcon title={identifier} />,
        identifier.replace('_', ' '),
        isActive,
        isMobile,
        params
      );
    }
    case 'STOPPED': {
      return createLabel(
        <OutlinedFlagRoundedIcon title={identifier} />,
        identifier,
        isActive,
        isMobile,
        params
      );
    }
    case 'FINISHED': {
      return createLabel(
        <FlagRoundedIcon title={identifier} />,
        identifier,
        isActive,
        isMobile,
        params
      );
    }
    default: {
      return createLabel(<TimelineGraficIcon title={identifier} />, identifier, isActive, isMobile);
    }
  }
};
